import { render, staticRenderFns } from "./PartnerManufacturerShowcaseDialog.vue?vue&type=template&id=07a7632f&"
import script from "./PartnerManufacturerShowcaseDialog.vue?vue&type=script&lang=js&"
export * from "./PartnerManufacturerShowcaseDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports